"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PollLearner = _interopRequireDefault(require("./PollLearner/PollLearner"));

var _PollCreator = _interopRequireDefault(require("./PollCreator/PollCreator"));

var _PollTeacherView = _interopRequireDefault(require("./PollTeacherView/PollTeacherView"));

var _PollResult = _interopRequireDefault(require("./PollResult/PollResult"));

// import PollTeacher from './PollTeacher/PollResults';
var Poll = {};
Poll.Learner = _PollLearner.default;
Poll.Creator = _PollCreator.default;
Poll.TeacherView = _PollTeacherView.default;
Poll.Result = _PollResult.default; // Poll.PollTeacher = PollTeacher;

var _default = Poll;
exports.default = _default;